import React from 'react';

import BooksMenuItem from '../../../../../molecules/merchant/resources/book/BooksMenuItem';
import { Lesson } from '../../../../../interfaces/merchants/resources/books';

interface Props {
  lessons: Lesson[];
  postable: boolean;
  onClick: (lesson: Lesson) => void;
}

const InputBookingTargetLessonSelector: React.FC<Props> = (props) => {
  const { lessons, postable } = props;

  const handleClickLesson = (e: React.MouseEvent<HTMLInputElement>) => {
    const { lessons, onClick } = props;
    const lesson = lessons.find((l) => String(l.id) === e.currentTarget.value)!;
    onClick(lesson);
  };

  return (
    <div>
      {lessons.map((lesson) => (
        <BooksMenuItem
          key={lesson.id}
          courseName={lesson.name}
          postable={postable}
          onClick={handleClickLesson}
          text={lesson.description}
          value={lesson.id}
        />
      ))}
    </div>
  );
};

export default InputBookingTargetLessonSelector;
